import React, { useEffect } from 'react';
import '../styles/Services.css';

const Services = () => {
  useEffect(() => {
    const revealOnScroll = () => {
      const reveals = document.querySelectorAll('.reveal');
      reveals.forEach(element => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < windowHeight - elementVisible) {
          element.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  return (
    <section className="services" id="services">
      <div className="services-bg" style={{backgroundImage: "url('/images/hero-eva-baris.jpg')"}}></div>
      <div className="container">
        <div className="services-intro reveal">
          <h2 className="section-title">Alles is communicatie</h2>
          <p className="services-subheading">Waar ik het verschil maak</p>
        </div>

        <div className="services-grid">
          <div className="service-card reveal">
            <h3 className="service-title">Adviseur, dicht op MT en directie</h3>
            <p className="service-description">
              Ik voel me thuis aan de directietafel én op de werkvloer. Ik help organisaties hun verhaal scherp te krijgen en te vertalen naar zichtbare impact: van positionering tot de lastige boodschap die wél moet landen.
            </p>
            <p className="service-description">
              Het liefst als vast onderdeel van een team: meedenken, koers bepalen en zorgen dat communicatie er echt toe doet.
            </p>
          </div>

          <div className="service-card reveal">
            <h3 className="service-title">Arbeidsmarktcommunicatie & werkgeversmerk</h3>
            <p className="service-description">
              Goede mensen vinden én houden begint bij een eerlijk verhaal over waar je voor staat. Arbeidsmarktcommunicatie is precies waar ik energie van krijg: laten zien waarom het ergens fijn werken is, zonder het mooier te maken dan het is.
            </p>
            <p className="service-description">
              Ik bouwde daar jaren aan, bij grote corporates en aan bureauzijde, voor organisaties met een echt verhaal.
            </p>
          </div>

          <div className="service-card reveal">
            <h3 className="service-title">Verhalen die verbinden, draagvlak dat blijft</h3>
            <p className="service-description">
              Mijn kracht: complexe materie terugbrengen tot een helder verhaal dat mensen meeneemt. Tussen afdelingen, in verandering of richting stakeholders maak ik de verbinding en zorg ik voor draagvlak.
            </p>
            <p className="service-description">
              Geen woorden om de woorden, maar verhalen die iets in beweging zetten en mensen meekrijgen in de richting die telt.
            </p>
          </div>
        </div>

        <p className="services-closing reveal">
          Het liefst voor een organisatie met een échte purpose. Met beide benen op de grond, de handen uit de mouwen, en samen iets neerzetten waar je trots op bent.
        </p>
      </div>
    </section>
  );
};

export default Services;